export const headerData = {
  tableName: 'Active Channels',
  hasExport: false,
  hasSearch: false,
  hasDelete: true,
  hasEdit: false,
  hasPaging: true,
  hasCheckbox: false,
  hasUploadCSV: false,
  deleteSubtext:
    'Will remove all their data, including associated files and permissions. Proceed?',
  fields: [
    {
      fieldName: 'channelName',
      headerName: 'Channel',
    },
    {
      fieldName: 'businessNumber',
      headerName: 'Business Number',
      hasMobile: true,
    },
  ],
};
